import { useState, FormEvent, ChangeEvent } from "react";
import { useTranslation } from "react-i18next";

export default function RegistrationSection() {
  const { t } = useTranslation();
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    lineId: "",
    location: "",
    need: "",
    question: "",
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    fetch("https://readdy.ai/api/form/d7ua14ong1a8777gd2hg", {
      method: "POST",
      body: new URLSearchParams(data as unknown as Record<string, string>),
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    }).then(() => {
      setSubmitted(true);
      setFormData({ name: "", phone: "", lineId: "", location: "", need: "", question: "" });
    });
  };

  if (submitted) {
    return (
      <section className="section-padding bg-cream" id="registration">
        <div className="container-main">
          <div className="max-w-2xl mx-auto text-center bg-white rounded-2xl border border-warm-gray/60 p-10 md:p-14">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-champagne/10 mx-auto mb-6">
              <i className="ri-checkbox-circle-line text-3xl text-champagne" />
            </div>
            <h3 className="mb-4">{t("seminars.reg.success")}</h3>
            <button
              onClick={() => setSubmitted(false)}
              className="btn-outline mt-2"
            >
              再次預約
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="section-padding bg-cream" id="registration">
      <div className="container-main">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <span className="tag-label mb-4 inline-block">{t("seminars.reg.label")}</span>
          <h2 className="mb-4">{t("seminars.reg.title")}</h2>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-2xl border border-warm-gray/60 p-6 md:p-10">
            <form data-readdy-form onSubmit={handleSubmit} className="space-y-5">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label htmlFor="reg-name" className="block text-base font-sans font-semibold text-graphite mb-2">
                    {t("seminars.reg.name")}
                  </label>
                  <input
                    id="reg-name"
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-warm-gray bg-cream/50 text-graphite text-[1.0625rem] font-sans focus:outline-none focus:border-champagne focus:ring-1 focus:ring-champagne/30 transition-all"
                  />
                </div>
                <div>
                  <label htmlFor="reg-phone" className="block text-base font-sans font-semibold text-graphite mb-2">
                    {t("seminars.reg.phone")}
                  </label>
                  <input
                    id="reg-phone"
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-warm-gray bg-cream/50 text-graphite text-[1.0625rem] font-sans focus:outline-none focus:border-champagne focus:ring-1 focus:ring-champagne/30 transition-all"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label htmlFor="reg-lineId" className="block text-base font-sans font-semibold text-graphite mb-2">
                    {t("seminars.reg.lineId")}
                  </label>
                  <input
                    id="reg-lineId"
                    type="text"
                    name="lineId"
                    value={formData.lineId}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg border border-warm-gray bg-cream/50 text-graphite text-[1.0625rem] font-sans focus:outline-none focus:border-champagne focus:ring-1 focus:ring-champagne/30 transition-all"
                  />
                </div>
                <div>
                  <label htmlFor="reg-location" className="block text-base font-sans font-semibold text-graphite mb-2">
                    {t("seminars.reg.location")}
                  </label>
                  <input
                    id="reg-location"
                    type="text"
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-warm-gray bg-cream/50 text-graphite text-[1.0625rem] font-sans focus:outline-none focus:border-champagne focus:ring-1 focus:ring-champagne/30 transition-all"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="reg-need" className="block text-base font-sans font-semibold text-graphite mb-2">
                  {t("seminars.reg.need")}
                </label>
                <select
                  id="reg-need"
                  name="need"
                  value={formData.need}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 rounded-lg border border-warm-gray bg-cream/50 text-graphite text-[1.0625rem] font-sans focus:outline-none focus:border-champagne focus:ring-1 focus:ring-champagne/30 transition-all"
                >
                  <option value="">請選擇</option>
                  <option value="自地自建">自地自建</option>
                  <option value="危老重建">危老重建</option>
                  <option value="家族土地規劃">家族土地規劃</option>
                  <option value="預製工法諮詢">預製工法諮詢</option>
                  <option value="預算評估">預算評估</option>
                  <option value="其他">其他</option>
                </select>
              </div>

              <div>
                <label htmlFor="reg-question" className="block text-base font-sans font-semibold text-graphite mb-2">
                  {t("seminars.reg.question")}
                </label>
                <textarea
                  id="reg-question"
                  name="question"
                  value={formData.question}
                  onChange={handleChange}
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 rounded-lg border border-warm-gray bg-cream/50 text-graphite text-[1.0625rem] font-sans focus:outline-none focus:border-champagne focus:ring-1 focus:ring-champagne/30 transition-all resize-none"
                />
                <p className="text-base text-medium-gray text-right mt-1">
                  {formData.question.length}/500
                </p>
              </div>

              <div className="flex flex-col sm:flex-row items-center gap-4 pt-2">
                <button type="submit" className="btn-primary w-full sm:w-auto">
                  {t("seminars.reg.submit")}
                </button>
                <a
                  href="https://lin.ee/OpssTIM"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-outline gap-2 w-full sm:w-auto justify-center"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-line-fill" />
                  </span>
                  {t("seminars.reg.lineCta")}
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}